import { Component, Inject, OnInit,ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-band-selector',
  templateUrl: './band-selector.component.html',
  styleUrls: ['./band-selector.component.scss']
})
export class BandSelectorComponent implements OnInit {
  selectedBands: any[] = [];
  bands: any[] = [];
  filteredBands: any[] = [];
  searchText = '';
  maxSelection = 3;

  constructor(
    public dialogRef: MatDialogRef<BandSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.selectedBands = [...(this.data.selectedBands || [])];
    this.loadBands(this.data.operatorKey);

    this.filteredBands = [...this.bands];
  }

  filterBands() {
    const val = this.searchText.toLowerCase();
    this.filteredBands = this.bands.filter((b) =>
      b.label.toLowerCase().includes(val),
    );
  }

  toggleBand(id: number) {
    const bandObj = this.bands.find((b) => b.id === id);
    if (!bandObj) return;

    const exists = this.selectedBands.some((b) => b.id === id);

    if (exists) {
      this.selectedBands = this.selectedBands.filter((b) => b.id !== id);
    } else if (this.selectedBands.length < this.maxSelection) {
      this.selectedBands.push(bandObj);
    }
  }

  isDisabled(id: number): boolean {
    return (
      this.selectedBands.length >= this.maxSelection &&
      !this.selectedBands.some((b) => b.id === id)
    );
  }

  isSelected(id: number): boolean {
    return this.selectedBands.some((b) => b.id === id);
  }

  apply() {
    this.dialogRef.close(this.selectedBands);
  }

  cancel() {
    this.dialogRef.close('cancel');
  }

  clearAllBands() {
    this.dialogRef.close('clear_bands');
    this.selectedBands = [];
  }

  loadBands(operatorKey: string) {
    this.apiService
      .getSensorBands(operatorKey)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.bands = (res?.data?.bands || []).map((bandValue: any) => ({
            id: bandValue.band,
            label: `Band ${bandValue.band} ( ${bandValue.wavelength} nm )`,
          }));

          this.filteredBands = [...this.bands];
        },
        error: (err) => {
          this.bands = [];
          this.filteredBands = [];
        },
      });
  }
}
